export default class LocalStoragePersistence {
  /**
   * Singleton instance
   * @type {LocalStoragePersistence}
   */
  static _instance = null;

  static getInstance() {
    if (!LocalStoragePersistence._instance) {
      LocalStoragePersistence._instance = new LocalStoragePersistence();
    }

    return LocalStoragePersistence._instance;
  }

  /**
   * Get item from local storage
   * @param {string} key
   * @returns {string}
   */
  getItem(key) {
    return localStorage.getItem(key);
  }

  /**
   * Set item in local storage
   * @param {string} key
   * @param {string} value
   */
  setItem(key, value) {
    localStorage.setItem(key, value);
  }

  /**
   * Remove item from local storage
   * @param {string} key
   */
  removeItem(key) {
    localStorage.removeItem(key);
  }
}
